<template>
    <page-container class="grid grid-cols-12 gap-8">
        <settings-sidebar></settings-sidebar>
        <!-- Tab cards -->
        <div ref="content" class="col-span-12 md:col-span-8 lg:col-span-10">
            <shopify-integration
                v-if="hash === 'shopify' || !hash"
                :ownsTeam="isAdminOrOwner"
                :isTeamAdmin="isAdminOrOwner"
            />

            <contact-collector
                v-if="hash === 'contact-collector'"
                :ownsTeam="isAdminOrOwner"
                :isTeamAdmin="isAdminOrOwner"
            />

            <salesforce-integration
                v-if="hash === 'salesforce' && FEATURES.salesforce_integration"
                :ownsTeam="isAdminOrOwner"
            />

            <hubspot-integration v-if="hash === 'hubspot' && FEATURES.hubspot_integration" :ownsTeam="isAdminOrOwner" />

            <calendly-integration
                v-if="hash === 'calendly' && FEATURES.calendly_integration && FEATURES.contact_groups"
                :ownsTeam="isAdminOrOwner"
            />

            <acuity-integration
                v-if="hash === 'acuity' && FEATURES.acuity_integration && FEATURES.contact_groups"
                :ownsTeam="isAdminOrOwner"
            />

            <ftp-pull-integration v-if="hash === 'ftp-pull' && ftpPullAvailable" :ownsTeam="isAdminOrOwner" />

            <ftp-pull-runs v-if="hash === 'ftp-pull-runs' && ftpPullAvailable" />

            <auth-configs-list v-if="hash === 'auth-configs' && FEATURES.api_destinations" />

            <api-destinations-list v-if="hash === 'api-destinations' && FEATURES.api_destinations" />
        </div>
    </page-container>
</template>

<script setup>
import SalesforceIntegration from './SalesforceIntegration.vue';
import ShopifyIntegration from './ShopifyIntegration.vue';
import HubspotIntegration from './HubspotIntegration.vue';
import AcuityIntegration from './AcuityIntegration.vue';
import CalendlyIntegration from './CalendlyIntegration.vue';
import FtpPullIntegration from './FtpPullIntegration.vue';
import FtpPullRuns from './FtpPullRuns.vue';
import ContactCollector from './ContactCollector.vue';
import ApiDestinationsList from './api-destinations/ApiDestinationsList.vue';
import AuthConfigsList from './auth-configs/AuthConfigsList.vue';
import PageContainer from '~/components/general/PageContainer.vue';
import SettingsSidebar from '../menus/SettingsSidebar.vue';
import { inject } from 'vue';
import { useSettingsHash } from '~/composables/useSettingsHash';

const FEATURES = inject('FEATURES');

const { hash, content } = useSettingsHash();

const isAdminOrOwner = Spark.isAdminOrOwner;
const ftpPullAvailable = Spark.ftpPullAvailable;
</script>
